// media.js
export function qxLazyImages() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.loading = 'lazy'; io.unobserve(e.target); } });
    }, { rootMargin: '120px' });
    document.querySelectorAll('.qx-card img').forEach(function (i) { io.observe(i); });
}

export function qxGalleryZoom() {
    document.querySelectorAll('.qx-product__media img').forEach(function (img) {
        img.addEventListener('mouseenter', function () { img.classList.add('qx-zoom'); });
        img.addEventListener('mouseleave', function () { img.classList.remove('qx-zoom'); });
    });
}
